module.exports = __webpack_public_path__ + "img/defaultItemImage.1b5d4cc4.png";